import React from "react";

const ArrowSort = ({ className }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7657 9.83438C11.9156 9.9844 11.9999 10.1878 11.9999 10.4C11.9999 10.6121 11.9156 10.8156 11.7657 10.9656L8.56566 14.1656C8.41564 14.3156 8.2122 14.3998 8.00006 14.3998C7.78793 14.3998 7.58449 14.3156 7.43447 14.1656L4.23447 10.9656C4.15806 10.8918 4.09711 10.8035 4.05518 10.7059C4.01326 10.6083 3.99119 10.5033 3.99026 10.3971C3.98934 10.2909 4.00958 10.1855 4.04981 10.0872C4.09003 9.98889 4.14943 9.89957 4.22455 9.82446C4.29966 9.74934 4.38898 9.68994 4.4873 9.64972C4.58562 9.60949 4.69096 9.58925 4.79719 9.59017C4.90341 9.5911 5.00839 9.61317 5.10599 9.65509C5.20359 9.69702 5.29187 9.75797 5.36566 9.83438L7.20006 11.6688V2.39998C7.20006 2.1878 7.28435 1.98432 7.43438 1.83429C7.58441 1.68426 7.78789 1.59998 8.00006 1.59998C8.21224 1.59998 8.41572 1.68426 8.56575 1.83429C8.71578 1.98432 8.80007 2.1878 8.80007 2.39998V11.6688L10.6345 9.83438C10.7845 9.6844 10.9879 9.60015 11.2001 9.60015C11.4122 9.60015 11.6156 9.6844 11.7657 9.83438Z"
      fill="#009FB8"
    />
  </svg>
);

export default ArrowSort;
